import React from 'react';
import { IAppointmentListPageContext } from 'shared/interfaces/appointment.list.interface';

export const Context = React.createContext<
  IAppointmentListPageContext | undefined
>(undefined);
